import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { redirectToPotatoLogin } from '@/services/Login/auth';
import LogoIcon from '@/assets/icons/logo.svg?react';

const brandGradient = 'bg-[linear-gradient(135deg,#AB00FF_0%,#00C8EB_100%)]';

const Login = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  // Guards against StrictMode's dev-only double-invoke of effects, which would
  // otherwise fire this toast twice for a single redirect.
  const invitationErrorShownRef = useRef(false);

  useEffect(() => {
    const invitationError = searchParams.get('invitationError');
    if (!invitationError || invitationErrorShownRef.current) return;
    invitationErrorShownRef.current = true;

    toast.error(invitationError);
    setSearchParams(
      (prev) => {
        prev.delete('invitationError');
        return prev;
      },
      { replace: true }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogin = () => {
    redirectToPotatoLogin();
  };

  return (
    <div className="flex h-screen items-center justify-center bg-[linear-gradient(135deg,#AB00FF_0%,#00C8EB_100%)] p-6">
      <div className="flex flex-col items-center w-90">
        <div className="flex w-full flex-col items-center rounded-[20px] border border-violet/10 bg-white px-8 py-12 shadow-violet">
          <div>
            <LogoIcon className="h-12 w-12 mb-4" />
          </div>

          <h1
            className={`mb-2 bg-clip-text font-heading text-[22px] font-bold leading-7 text-transparent ${brandGradient}`}
          >
            CodiSoc
          </h1>

          <p className="mb-6 text-center text-sm leading-[22px] text-fg-3">
            Sign in to your Coditas account
          </p>

          <button
            type="button"
            onClick={handleLogin}
            className={`flex h-14 w-full cursor-pointer items-center justify-center rounded-xl ${brandGradient} text-sm font-semibold text-white transition hover:opacity-90 hover:shadow-[0_4px_16px_oklch(0.5377_0.27624_307.06/0.35)] active:opacity-10`}
          >
            Login with Coditas
          </button>
        </div>

        <p className="mt-6 text-center text-xs leading-[18px] text-white/65">
          Protected by Coditas Security
        </p>
      </div>
    </div>
  );
};

export default Login;
